import React from 'react';
import PracticeDetailPage from './PracticeDetailPage';

export default function PracticeMedicalDevices() {
  return (
    <PracticeDetailPage
      practiceId="medical-devices"
      canonicalPath="/practice/medical-devices"
    />
  );
}
